'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    progress = require('./progress'),
    util = require('./util');

var selectedList = [];
var maxItems = 1;
var bliUUID = '';

/**
 * @private
 * @function
 * description Gets a list of bonus products related to a promoted product
 */
function getBonusProducts() {
    var bonusproducts = [];

    var i, len;
    for (i = 0, len = selectedList.length; i < len; i++) {
        var p = {
            pid: selectedList[i].pid,
            uuid: selectedList[i].uuid,
            qty: selectedList[i].qty,
            options: {}
        };
        var a, alen, bp = selectedList[i];
        if (bp.options) {
            for (a = 0, alen = bp.options.length; a < alen; a++) {
                var opt = bp.options[a];
                p.options = {optionName:opt.name, optionValue:opt.value};
            }
        }
        bonusproducts.push({product:p});
    }
    return {bonusproducts: bonusproducts};
}

var selectedItemTemplate = function (data) {
    var attributes = '';
    for (var attrID in data.attributes) {
        var attr = data.attributes[attrID];
        attributes += '<li data-attribute-id="' + attrID + '">\n';
        attributes += '<span class="display-name">' + attr.displayName + '</span>: ';
        attributes += '<span class="display-value">' + attr.displayValue + '</span>\n';
        attributes += '</li>';
    }
    attributes += '<li class="item-qty">\n';
    attributes += '<span class="display-name">Qty</span>: ';
    attributes += '<span class="display-value">' + data.qty + '</span>';
    return [
        '<li class="selected-bonus-item" data-uuid="' + data.uuid + '" data-pid="' + data.pid + '">',
        '<span class="remove-link" title="Remove this product" href="#">' + Resources.REMOVE + '</span>',
        '<div class="item-name">' + data.name + '</div>',
        '<ul class="item-attributes">',
        attributes,
        '<ul>',
        '<li>'
    ].join('\n');
};

// hide swatches that are not selected or not part of a Product Variation Group
var hideSwatches = function () {
    $('.bonus-product-item:not([data-producttype="master"]) .swatches li').not('.selected').not('.variation-group-value').hide();
    // prevent unselecting the selected variant
    $('.bonus-product-item .swatches .selected').on('click', function () {
        return false;
    });
};

/**
 * @private
 * @function
 * @description Updates the summary page with the selected bonus product
 */
function updateSummary() {
    var $bonusProductList = $('#bonus-product-list');
    var remain = maxItems;

    $bonusProductList.find('li.selected-bonus-item').remove();//Reset visible list
    if (selectedList.length) {
        var ulList = $bonusProductList.find('ul.selected-bonus-items').first();
        var i, len;
        for (i = 0, len = selectedList.length; i < len; i++) {
            var item = selectedList[i];
            var li = selectedItemTemplate(item);
            $(li).appendTo(ulList);

            remain -= item.qty;
        }
    }

    // get remaining item count
    $bonusProductList.find('.bonus-items-available').text(remain);
    if (remain <= 0) {
        $bonusProductList.find('.select-bonus-item').prop('disabled', true);
    } else {
        $bonusProductList.find('.select-bonus-item[data-available="true"]').prop('disabled', false);
    }
}

function markDialogUpdatesPending() {
    // mark any currently existing bonus product dialogs as having pending bonus product updates so that the page refreshes when the dialog closes
    if ($('#bonus-product-dialog').length && !$('#bonus-product-dialog').hasClass('bp-updates-pending')) {
        $('#bonus-product-dialog').addClass('bp-updates-pending');
    }
    if ($('#bonus-product-list').length && !$('#bonus-product-list').hasClass('bp-updates-pending')) {
        $('#bonus-product-list').addClass('bp-updates-pending');
    }
    return;
}

function initializeGrid () {
    var $bonusProduct = $('#bonus-product-dialog'),
        $bonusProductList = $('#bonus-product-list'),
        bliData = $bonusProductList.data('line-item-detail');
    maxItems = bliData.maxItems;
    bliUUID = bliData.uuid;

    if (bliData.itemCount >= maxItems) {
        $bonusProductList.find('.select-bonus-item').prop('disabled', true);
    }

    if($bonusProductList.find('.c-bonus-product-item').hasClass('c-bonus-product-item--single')) {
        $('.js .ui-dialog').css('max-width', 'fit-content   ');
    }

    var cartItems = $bonusProductList.find('.selected-bonus-item');
    cartItems.each(function () {
        var ci = $(this);
        var product = {
            uuid: ci.data('uuid'),
            pid: ci.data('pid'),
            qty: 1,
            name: ci.find('.item-name').html(),
            attributes: {}
        };
        var attributes = ci.find('ul.item-attributes li');
        attributes.each(function () {
            var li = $(this);
            product.attributes[li.data('attributeId')] = {
                displayName:li.children('.display-name').html(),
                displayValue:li.children('.display-value').html()
            };
        });
        selectedList.push(product);
    });

    $bonusProductList.on('click', '.c-bonus-product-item a[href].swatchanchor', function (e) {
        var uuid = $('.c-bonus-product__list').data('line-item-detail').uuid;

        e.preventDefault();
        var url = this.href,
            $this = $(this);
        url = util.appendParamsToUrl(url, {
            'source': 'bonus',
            'bonusDiscountLineItemUUID': uuid,
            'format': 'ajax'
        });
        $.ajax({
            url: url,
            success: function (response) {
                $this.closest('.c-bonus-product-item').empty().html(response);
                hideSwatches();
            }
        });
    })
    .on('change', '.c-bonus-product-item .input-select', function (e) {
        var uuid = $('.c-bonus-product__list').data('line-item-detail').uuid;

        e.preventDefault();
        var url = this.value,
            $this = $(this);
        url = url.replace(/&source=detail/, ''); //Prevent the wrong content from being loaded when selecting an option from dropdown
        url = util.appendParamsToUrl(url, {
            'source': 'bonus',
            'bonusDiscountLineItemUUID': uuid,
            'format': 'ajax',
            'ProdsInCart': ProdsInCart
        });
        $.ajax({
            url: url,
            success: function (response) {
                $this.closest('.c-bonus-product-item').empty().html(response);
            }
        });
    })
    .on('change', '.input-text', function () {
        $bonusProductList.find('.select-bonus-item[data-available="true"]').removeAttr('disabled');
        $(this).closest('.bonus-product-form').find('.quantity-error').text('');
    })
    .on('click', '.select-bonus-item', function (e) {
        e.preventDefault();
        if (selectedList.length >= maxItems) {
            $bonusProductList.find('.select-bonus-item').prop('disabled', true);
            // $bonusProductList.find('.bonus-items-available').text('0'); //this element seems to have been removed
            return;
        }

        var form = $(this).closest('.bonus-product-form'),
            detail = $(this).closest('.product-detail'),
            uuid = form.find('input[name="productUUID"]').val(),
            qtyVal = form.find('input[name="Quantity"]').val(),
            qty = (isNaN(qtyVal)) ? 1 : (+qtyVal);

        if (qty > maxItems) {
            $bonusProductList.find('.select-bonus-item').prop('disabled', true);
            form.find('.quantity-error').text(Resources.BONUS_PRODUCT_TOOMANY);
            return;
        }

        var product = {
            uuid: uuid,
            pid: form.find('input[name="pid"]').val(),
            qty: qty,
            name: detail.find('.product-name').text(),
            attributes: detail.find('.product-variations').data('attributes'),
            options: []
        };

        var optionSelects = form.find('.product-option');

        if (optionSelects.length > 0) {
            optionSelects.each(function () {
                product.options.push({
                    name: this.name,
                    value: $(this).val(),
                    display: $(this).children(':selected').first().html()
                });
            });
        }

        if(!product.attributes) {
            var attributes = JSON.parse(form.find('input[name="productAtts"]').val());
            product.attributes = [];
            window.test = attributes;

            for(var attr in attributes) {
                attr = attributes[attr];
                if(!attr.value) {
                    continue;
                }
                product.attributes.push({displayName: attr.name, displayValue: attr.value});
            }
        }

        var thisUUID = $(e.currentTarget).siblings('input[name="productUUID"]').val();
        var thisPID = $(e.currentTarget).siblings('input[name="pid"]').val();
        var thisAtts = $(e.currentTarget).siblings('input[name="productAtts"]').val();
        var productID = $('.js-product-pid').length ? $('.js-product-pid').val() : document.getElementById('relatedProductId').value;
        var bonusProductAction = document.getElementById('bonusProductAction').value;
        var oldBonusDiscountLineUUID = null;
        if (!productID) {
            productID = null;
        }
        if(bonusProductAction && bonusProductAction === 'bonuschange') {
            oldBonusDiscountLineUUID = $(this).parents('#bonus-product-list').find('.remove-bonus-from-cart.selected').parents('.bonus-product-form').find('input[name="pid"]').val();
        }

        var url = util.appendParamsToUrl(Urls.addBonusProduct, {bonusDiscountLineItemUUID: bliUUID});
        $(this).parents('.c-bonus-product-item').find('.product-variations').addClass('locked');
        // make the server call
        progress.show($('#bonus-product-dialog'));
        $.ajax({
            type: 'POST',
            dataType: 'json',
            cache: false,
            contentType: 'application/json',
            url: url,
            data: '{"bonusproducts":[{"product": {"pid": '+ thisPID +',"uuid": "' + thisUUID + '","qty": 1, "options":' + thisAtts +', "pliID":' + productID +', "oldBonusDiscountLineUUID":"' + oldBonusDiscountLineUUID +'" }}]}'
        }).success(function(data){
            progress.hide();
            var bonusHiddenContainer = document.querySelector('#bonusProductMessage');
            bonusHiddenContainer.value = data.bonusProductMessage;
        })

        selectedList.push(product);
        updateSummary();
        //hide this button and reveal its related remove link
        $(this).hide();
        $(this).siblings('a.remove-bonus-from-cart').show();
        // mark the dialog as having pending bonus product updates so that the page refreshes when the dialog closes
        markDialogUpdatesPending();
        dialog.close();
    })
    // ajax removal of bonus items
    .on('click', '.remove-bonus-from-cart', function (e) {
        e.preventDefault();
        progress.show($('#bonus-product-dialog'));
        $(this).siblings('.select-bonus-item').show().prop('disabled', false);
        $(this).hide();
        $(this).parents('.c-bonus-product-item').find('.product-variations').removeClass('locked');
        //remove the item from the hidden accumulative list
        var thisUUID = $(this).siblings('input[name=productUUID]').val();
        $('.selected-bonus-item[data-uuid=' + thisUUID + ']').find('.remove-link').click();
        $.ajax({
            type: 'POST',
            url: $(this).attr('href')
        }).success(function(){
            //alert('removed')
            progress.hide();
            markDialogUpdatesPending();
        })
    })
    .on('click', '.remove-bonus-item', function(e){
        // this is a button that replaces the select-bonus-item button & undoes its effects when clicked
        e.preventDefault();
    })
    .on('click', '.remove-link', function (e) {
        e.preventDefault();
        var container = $(this).closest('.selected-bonus-item');
        if (!container.data('uuid')) { return; }

        var uuid = container.data('uuid');
        var i, len = selectedList.length;
        for (i = 0; i < len; i++) {
            if (selectedList[i].uuid === uuid) {
                selectedList.splice(i, 1);
                break;
            }
        }
        updateSummary();
    })
    .on('click', '.add-to-cart-bonus', function (e) {
        e.preventDefault();
        var url = util.appendParamsToUrl(Urls.addBonusProduct, {bonusDiscountLineItemUUID: bliUUID});
        var bonusProducts = getBonusProducts();
        if (bonusProducts.bonusproducts[0].product.qty > maxItems) {
            bonusProducts.bonusproducts[0].product.qty = maxItems;
        }
        // make the server call
        $.ajax({
            type: 'POST',
            dataType: 'json',
            cache: false,
            contentType: 'application/json',
            url: url,
            data: JSON.stringify(bonusProducts)
        })
        .done(function () {
            // success
            page.refresh();
        })
        .fail(function (xhr, textStatus) {
            // failed
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        })
        .always(function () {
            // $bonusProduct.dialog('close');
        });
    })
    .on('click', '#more-bonus-products', function (e) {
        e.preventDefault();
        var uuid = $('#bonus-product-list').data().lineItemDetail.uuid;

        //get the next page of choice of bonus products
        var lineItemDetail = JSON.parse($('#bonus-product-list').attr('data-line-item-detail'));
        lineItemDetail.pageStart = lineItemDetail.pageStart + lineItemDetail.pageSize;
        $('#bonus-product-list').attr('data-line-item-detail', JSON.stringify(lineItemDetail));

        var url = util.appendParamsToUrl(Urls.getBonusProducts, {
            bonusDiscountLineItemUUID: uuid,
            format: 'ajax',
            lazyLoad: 'true',
            pageStart: lineItemDetail.pageStart,
            pageSize: $('#bonus-product-list').data().lineItemDetail.pageSize,
            bonusProductsTotal: $('#bonus-product-list').data().lineItemDetail.bpTotal
        });

        $.ajax({
            type: 'GET',
            cache: false,
            contentType: 'application/json',
            url: url
        })
        .done(function (data) {
            //add the new page to DOM and remove 'More' link if it is the last page of results
            $('#more-bonus-products').before(data);
            if ((lineItemDetail.pageStart + lineItemDetail.pageSize) >= $('#bonus-product-list').data().lineItemDetail.bpTotal) {
                $('#more-bonus-products').remove();
            }
        })
        .fail(function (xhr, textStatus) {
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        });
    });
}

var bonusProductsView = {
    /**
     * @function
     * @description Open the list of bonus products selection dialog
     */
    show: function (url) {
        var $bonusProduct = $('#bonus-product-dialog');
        // create the dialog
        dialog.open({
            target: $bonusProduct,
            url: url,
            options: {
                width: 795,
                dialogClass: 'bonus-product-modal',
                title: Resources.BONUS_PRODUCTS,
                close: function close() {
                    if ($('#bonus-product-dialog').hasClass('bp-updates-pending')) {
                        // when the user closes the dialog, refresh the page if bonus product updates have been made.
                        progress.show($('html'));
                        location.reload();
                    }
                    $('body').css('overflow', 'initial');
                }
            },
            callback: function () {
                initializeGrid();
                hideSwatches();
            }
        });
    },
    /**
     * @function
     * @description Open bonus product promo prompt dialog
     */
    loadBonusOption: function () {
        var    self = this,
            bonusDiscountContainer = document.querySelector('#bonus-product-list');
        if (!bonusDiscountContainer) { return; }

        // get the html from minicart, then trash it
        var bonusDiscountContainerHtml = bonusDiscountContainer.outerHTML;
        bonusDiscountContainer.parentNode.removeChild(bonusDiscountContainer);

        dialog.open({
            html: bonusDiscountContainerHtml,
            options: {
                dialogClass: 'bonus-product-modal',
                title: Resources.BONUS_PRODUCT,
                close: function close() {
                    if ($('#bonus-product-list').hasClass('bp-updates-pending')) {
                        // when the user closes the dialog, refresh the page if bonus product updates have been made.
                        var minicart = require('./minicart');
                        minicart.refreshMinicart();
                    }
                    $('body').css('overflow', 'initial');
                    $('.mini-cart-content').removeClass('has-bonus-product-modal');
                }
            },
            callback: function () {
                // show hide promo details
                $('.show-promo-details').on('click', function () {
                    $('.promo-details').toggleClass('visible');
                });
                $('.mini-cart-content').addClass('has-bonus-product-modal');
                initializeGrid();
            }
        });
    }
};

module.exports = bonusProductsView;
